import React, { useState, useEffect } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    Box,
} from "@mui/material";

const MedalDialog = ({
    open,
    onClose,
    onSubmit,
    initialValues = null,
}) => {
    const [titleDe, setTitleDe] = useState("");
    const [titleEn, setTitleEn] = useState("");
    const [descriptionDe, setDescriptionDe] = useState("");
    const [descriptionEn, setDescriptionEn] = useState("");
    const [priority, setPriority] = useState(0);

    useEffect(() => {
        if (initialValues) {
            setTitleDe(initialValues.title_de || "");
            setTitleEn(initialValues.title_en || "");
            setDescriptionDe(initialValues.description_de || "");
            setDescriptionEn(initialValues.description_en || "");
            setPriority(initialValues.priority || 0);
        } else {
            setTitleDe("");
            setTitleEn("");
            setDescriptionDe("");
            setDescriptionEn("");
            setPriority(0);
        }
    }, [initialValues]);

    const handleSave = () => {
        if (!titleDe || !titleEn || !descriptionDe || !descriptionEn) {
            alert("Bitte alle Felder ausfüllen");
            return;
        }

        onSubmit({
            title_de: titleDe,
            title_en: titleEn,
            description_de: descriptionDe,
            description_en: descriptionEn,
            priority: priority,
        });
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth>
            <DialogTitle>
                {initialValues ? "Medaille bearbeiten" : "Neue Medaille hinzufügen"}
            </DialogTitle>
            <DialogContent>
                <Box display="flex" flexDirection="column" gap={2} mt={1}>
                    <TextField
                        label="Titel (Deutsch)"
                        value={titleDe}
                        onChange={(e) => setTitleDe(e.target.value)}
                        fullWidth
                    />
                    <TextField
                        label="Titel (Englisch)"
                        value={titleEn}
                        onChange={(e) => setTitleEn(e.target.value)}
                        fullWidth
                    />
                    <TextField
                        label="Beschreibung (Deutsch)"
                        value={descriptionDe}
                        onChange={(e) => setDescriptionDe(e.target.value)}
                        fullWidth
                    />
                    <TextField
                        label="Beschreibung (Englisch)"
                        value={descriptionEn}
                        onChange={(e) => setDescriptionEn(e.target.value)}
                        fullWidth
                    />
                    <TextField
                        label="Priorität (höher = weiter oben)"
                        type="number"
                        value={priority}
                        onChange={(e) => setPriority(parseInt(e.target.value) || 0)}
                        fullWidth
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Abbrechen</Button>
                <Button variant="contained" onClick={handleSave}>
                    {initialValues ? "Speichern" : "Hinzufügen"}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default MedalDialog;
